import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

/** Performance analytics tile: avg approval, estimates/claim, top carriers bar list. */
export function AnalyticsCard({ analytics }) {
  if (!analytics) return null;
  const max = (analytics.top_carriers || [])[0]?.count || 1;
  return (
    <Card className="border-[#E5E7EB] mb-10">
      <CardHeader>
        <CardTitle className="font-['Outfit'] flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-[#C25934]" />
          Performance analytics
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-3 gap-6">
          <div data-testid="analytic-avg-approval">
            <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">
              Avg time to approval
            </p>
            <p className="font-['Outfit'] text-3xl font-semibold text-[#1E3F33]">
              {analytics.avg_hours_to_approval != null
                ? `${analytics.avg_hours_to_approval}h`
                : "—"}
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Based on {analytics.approvals_sample_size} approval
              {analytics.approvals_sample_size === 1 ? "" : "s"}
            </p>
          </div>
          <div data-testid="analytic-estimates-per-claim">
            <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">
              Estimates per claim
            </p>
            <p className="font-['Outfit'] text-3xl font-semibold text-[#1E3F33]">
              {analytics.estimates_per_claim}
            </p>
            <p className="text-xs text-gray-500 mt-1">
              {analytics.total_estimates} estimates · {analytics.total_claims}{" "}
              claims
            </p>
          </div>
          <div data-testid="analytic-top-carriers">
            <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">
              Top carriers
            </p>
            <div className="space-y-1.5">
              {(analytics.top_carriers || []).slice(0, 4).map((c) => {
                const pct = Math.max(8, (c.count / max) * 100);
                return (
                  <div key={c.carrier} className="flex items-center gap-3">
                    <span className="text-sm w-28 capitalize truncate">
                      {(c.carrier || "").replace("-", " ")}
                    </span>
                    <div className="flex-1 h-2 rounded-full bg-[#F9F8F6] overflow-hidden">
                      <div
                        className="h-full bg-[#1E3F33]"
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                    <span className="text-xs font-medium text-gray-700 w-6 text-right">
                      {c.count}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
